import { MBTIScore } from '../types/game';

export const calculateMBTIType = (scores: MBTIScore): string => {
  const type = [
    scores.E > scores.I ? 'E' : 'I',
    scores.S > scores.N ? 'S' : 'N',
    scores.T > scores.F ? 'T' : 'F',
    scores.J > scores.P ? 'J' : 'P'
  ].join('');

  return type;
};

export const getMBTIDescription = (type: string): string => {
  const descriptions: Record<string, string> = {
    'ISTJ': '你是一位谨慎的观察者，善于发现规律与秩序。在这片神秘的森林中，你的分析能力帮助你理解了这个世界的运作方式。',
    'ISFJ': '你是一位温和的守护者，对周围的生命充满关怀。在森木星球上，你与自然建立了深厚的情感联系。',
    'INFJ': '你是一位富有洞察力的理想主义者，能够看到事物更深层的意义。在这片奇妙的土地上，你感受到了生命的和谐与神秘。',
    'INTJ': '你是一位富有远见的策略家，善于发现系统中的规律。在森木星球上，你敏锐地察觉到了能量与意识的奥秘。',
    'ISTP': '你是一位灵活的探索者，善于理解事物的运作机制。在这片未知的土地上，你的实践能力帮助你适应新环境。',
    'ISFP': '你是一位敏感的艺术家，能够感受到生命的美好。在森木星球上，你与自然产生了独特的共鸣。',
    'INFP': '你是一位理想主义的梦想家，对生命充满好奇与同理心。在这片神奇的土地上，你找到了心灵的归属。',
    'INTP': '你是一位创新的思考者，善于发现事物背后的原理。在森木星球上，你的求知欲望帮助你理解了这个世界的本质。',
    'ESTP': '你是一位充满活力的冒险家，善于把握当下的机会。在这片未知的土地上，你展现出了非凡的适应能力。',
    'ESFP': '你是一位开朗的表演者，能够让周围的氛围变得活跃。在森木星球上，你与生命之间建立了愉快的互动。',
    'ENFP': '你是一位热情的探索者，对新事物充满好奇。在这片神奇的土地上，你发现了无限的可能性。',
    'ENTP': '你是一位创新的思想家，善于发现新的视角。在森木星球上，你的创造力帮助你理解了这个世界的多样性。',
    'ESTJ': '你是一位果断的组织者，善于建立秩序与效率。在这片未知的土地上，你展现出了卓越的领导能力。',
    'ESFJ': '你是一位友善的照顾者，善于营造和谐的氛围。在森木星球上，你与生命之间建立了深厚的友谊。',
    'ENFJ': '你是一位富有魅力的引导者，能够激发他人的潜能。在这片神奇的土地上，你成为了沟通的桥梁。',
    'ENTJ': '你是一位果断的领导者，善于制定策略与目标。在森木星球上，你展现出了非凡的远见卓识。'
  };

  return descriptions[type] || '你是一位独特的探索者，在森木星球上留下了属于自己的足迹。';
}; 